/**
 * Searches a grant's name, location, and description for given strings.
 * @param {object} grant - A single grant object.
 * @param {array} searchStrings - an array of search terms.
 * @returns {boolean}
 */
export default function searchGrantFields(grant, searchStrings) {
  const {
    description,
    location,
    name,
  } = grant;
  return searchStrings.map((search) => {
    const searchStr = search.toLowerCase();
    return (- 1 < name.toLowerCase().indexOf(searchStr)) ||
      (- 1 < location.toLowerCase().indexOf(searchStr)) ||
      (- 1 < description.toLowerCase().indexOf(searchStr));
  }).some((item) => item);
}
